/* tslint:disable */
/* eslint-disable */
/**
 * Rooming_API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Paging
 */
export interface Paging {
    /**
     * 
     * @type {number}
     * @memberof Paging
     */
    size?: number;
    /**
     * 
     * @type {number}
     * @memberof Paging
     */
    skip?: number;
    /**
     * 
     * @type {string}
     * @memberof Paging
     */
    orderBy?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Paging
     */
    orderByDesc?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Paging
     */
    filterBy?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Paging
     */
    filterByValue?: string | null;
}

export function PagingFromJSON(json: any): Paging {
    return PagingFromJSONTyped(json, false);
}

export function PagingFromJSONTyped(json: any, ignoreDiscriminator: boolean): Paging {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'size': !exists(json, 'size') ? undefined : json['size'],
        'skip': !exists(json, 'skip') ? undefined : json['skip'],
        'orderBy': !exists(json, 'orderBy') ? undefined : json['orderBy'],
        'orderByDesc': !exists(json, 'orderByDesc') ? undefined : json['orderByDesc'],
        'filterBy': !exists(json, 'filterBy') ? undefined : json['filterBy'],
        'filterByValue': !exists(json, 'filterByValue') ? undefined : json['filterByValue'],
    };
}

export function PagingToJSON(value?: Paging | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'size': value.size,
        'skip': value.skip,
        'orderBy': value.orderBy,
        'orderByDesc': value.orderByDesc,
        'filterBy': value.filterBy,
        'filterByValue': value.filterByValue,
    };
}

